import {
  Box,
  Checkbox,
  FormControl,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
  Tabs,
  Tab,
  CircularProgress,
} from "@material-ui/core";
import ChipInput from "material-ui-chip-input";
import { withRouter, useHistory, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CustomAutoComplete from "../../../common/CustomAutoComplete";
import { updateObjectStateValue } from "../../../utils/FunctionHelpers";
import { Button } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";

function TabPanel({ value, index, children }) {
  return (
      <div role="tabpanel" hidden={value !== index}>
        {value === index && <Box style={{ paddingTop: "16px" }}>{children}</Box>}
      </div>
  );
}

const MultiCritere = ({
  classes,
  addParam,
  parameters,
  searchKeys,
  setSearchKeys,
  loading,
  selectionsData,
  handleSearch,
  nomFamille,
  handleNameChecked,
  searchMode,
  handleSearchModeChange,
  setMultiOpen,
  onAgentSearch,
}) => {
  const history = useHistory();
  const location = useLocation();

  const [tab, setTab] = useState(0);
  const handleTabChange = (_e, v) => setTab(v);

  const [iaTab, setIaTab] = useState(0);
  const handleIaTabChange = (_e, v) => setIaTab(v);

  const getInitialAgentText = () => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get("agentText") || "";
  };
  const [agentText, setAgentText] = useState(getInitialAgentText);

  const ia = parameters?.iaForm || {};
  const setIA = (patch) =>
      addParam({ target: { name: "iaForm", value: { ...ia, ...patch } } });
  const setExperienceField = (k, v) =>
      setIA({ experience: { ...(ia.experience || {}), [k]: v } });

  const handleDeleteChip = (index) => {
    const newChips = [...searchKeys.motsCle];
    newChips.splice(index, 1);

    updateObjectStateValue(setSearchKeys, { motsCle: newChips });
  };

  const handleChangeSociete = (societe) => {
    updateObjectStateValue(setSearchKeys, { societe });
  };

  const handleChangeSelection = (selection) => {
    updateObjectStateValue(setSearchKeys, { selection });
  };

  const handleApplySearch = () => {
    handleSearch(parameters);
    setMultiOpen(false);
  };

  const handleApplyIaSearch = () => {
    const payload = {
      isAiSearch: true,
      categorie: parameters.categorie || "candidat",
      loc: ia.loc || [],
      exclude: ia.exclude || "",
      skills: ia.skills || [],
      programming_languages: ia.programming_languages || [],
      role: ia.role || "",
      experience_min: ia.experience?.min,
      experience_max: ia.experience?.max,
      industry: ia.industry || [],
    };
    Object.keys(payload).forEach((key) => {
      if (
          payload[key] === "" || payload[key] === null || payload[key] === undefined ||
          (Array.isArray(payload[key]) && payload[key].length === 0)
      ) {
        delete payload[key];
      }
    });
    const params = new URLSearchParams();
    Object.entries(payload).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => params.append(`${key}[]`, item));
      } else {
        params.append(key, value);
      }
    });
    history.push(`/accueil/chercher?${params.toString()}`);
    setMultiOpen(false);
  };

  const handleApplyAgentSearch = () => {
    const trimmedAgentText = agentText.trim();
    if (!trimmedAgentText) return;

    const params = new URLSearchParams();
    params.set("categorie", parameters.categorie || "candidat");
    params.set("isAiSearch", "true");
    params.set("iaMode", "agent");
    params.set("agentText", trimmedAgentText);

    history.push(`/accueil/chercher?${params.toString()}`);
    setMultiOpen(false);
  };

  const iaEmpty =
      !(ia.loc?.length) && !ia.exclude &&
      !(ia.skills?.length) && !(ia.programming_languages?.length) &&
      !ia.role && !(ia.industry?.length) &&
      !ia.experience?.min && !ia.experience?.max;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const isAiSearch = searchParams.get("isAiSearch") === "true";
    const iaMode = searchParams.get("iaMode");
    const agentTextFromQuery = searchParams.get("agentText") || "";
    setTab(isAiSearch ? 1 : 0);
    setIaTab(iaMode === "agent" || !!agentTextFromQuery ? 1 : 0);
    if (agentTextFromQuery) setAgentText(agentTextFromQuery);
  }, [location.search]);

  return (
      <Box style={{ overflowY: "hidden", width: "100%", maxHeight: "100vh" }}>
        <Box style={{ backgroundColor: "#117aa7" }}>
          <Tabs
              value={tab}
              onChange={handleTabChange}
              variant="fullWidth"
              textColor="inherit"
              TabIndicatorProps={{ style: { background: "white" } }}
          >
            <Tab label={<Typography style={{ color: "white", fontWeight: 600 }}>FILTRER PAR MOT CLÉ</Typography>} />
            <Tab label={<Typography style={{ color: "white", fontWeight: 600 }}>FILTRER PAR IA</Typography>} />
          </Tabs>
        </Box>

        <Box style={{ padding: "16px", height: "94vh", overflowY: "auto" }}>

          <TabPanel value={tab} index={0}>
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12}>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <Select
                      value={parameters.categorie}
                      name="categorie"
                      onChange={(e) => addParam(e)}
                      input={<OutlinedInput name="categorie" />}
                  >
                    {[
                      { value: "candidat", label: "CANDIDAT" },
                      { value: "contact", label: "CONTACT" },
                    ].map((item) => (
                        <MenuItem value={item.value} key={item.value}>{item.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <Select
                      value={parameters.motsCleCategorie}
                      name="motsCleCategorie"
                      onChange={(e) => addParam(e)}
                      input={<OutlinedInput name="categorie" />}
                  >
                    {[
                      { value: "fonction", label: "FONCTION" },
                      { value: "champs", label: "CHAMPS" },
                      { value: "cv", label: "CV" },
                      { value: "notes", label: "NOTES" },
                      { value: "tous", label: "TOUS" },
                    ]
                        .filter((item) => item.value !== "cv" || parameters.categorie === "candidat")
                        .map((item) => (
                            <MenuItem value={item.value} key={item.value}>{item.label}</MenuItem>
                        ))}
                  </Select>
                </FormControl>
                {parameters.categorie !== "contact" && (
                    <FormControl variant="outlined" fullWidth margin="normal">
                      <CustomAutoComplete
                          listData={selectionsData.selections}
                          value={searchKeys.selection}
                          handleDataChange={handleChangeSelection}
                          name="selection"
                          onChange={(e) => addParam(e)}
                      />
                    </FormControl>
                )}
              </Grid>
              <Grid item xs={12}>
                <Box>
                  <ChipInput
                      value={searchKeys.motsCle}
                      onAdd={(chip) => updateObjectStateValue(setSearchKeys, { motsCle: [...searchKeys.motsCle, chip] })}
                      onDelete={(chip, index) => handleDeleteChip(index)}
                      margin="normal"
                      variant="outlined"
                      autoComplete="off"
                      fullWidth
                  />
                  <FormControl component="fieldset" style={{ marginTop: "10px" }}>
                    <RadioGroup row value={searchMode} onChange={handleSearchModeChange} name="searchMode">
                      <FormControlLabel value="or" control={<Radio color="primary" />} label={<Typography className={classes.fontStyle}>Un des termes</Typography>} />
                      <FormControlLabel value="and" control={<Radio color="primary" />} label={<Typography className={classes.fontStyle}>Tous les termes</Typography>} />
                      <FormControlLabel value="exact" control={<Radio color="primary" />} label={<Typography className={classes.fontStyle}>Phrase Exacte</Typography>} />
                    </RadioGroup>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <label className="input-label">LOCALISATION</label>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <TextField name="localisation" value={parameters?.localisation ?? ""} onChange={(e) => addParam(e)} variant="outlined" autoComplete="off" />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <label className="input-label">SAUF</label>
                <FormControl variant="outlined" fullWidth margin="normal">
                  <TextField name="localisationSauf" value={parameters?.localisationSauf ?? ""} onChange={(e) => addParam(e)} variant="outlined" autoComplete="off" />
                </FormControl>
              </Grid>
              {parameters.categorie !== "contact" && (
                  <>
                    <Grid item xs={12} md={6}>
                      <Box>
                        <label className="input-label">CONSULTANT</label>
                        <FormControl variant="outlined" fullWidth margin="normal">
                          <Select value={parameters?.sourceur ?? ""} name="sourceur" onChange={(e) => addParam(e)}>
                            {loading
                                ? [<Box key="l1" display="flex" justifyContent="center"><CircularProgress /></Box>]
                                : [<MenuItem value="" key="-">-</MenuItem>, ...selectionsData.consultants.map((u) => <MenuItem value={u.uuid} key={u.uuid}>{u.user}</MenuItem>)]}
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box>
                        <label className="input-label">DELIVERY MANAGER</label>
                        <FormControl variant="outlined" fullWidth margin="normal">
                          <Select value={parameters?.consultant ?? ""} name="consultant" onChange={(e) => addParam(e)}>
                            {loading
                                ? [<Box key="l2" display="flex" justifyContent="center"><CircularProgress /></Box>]
                                : [<MenuItem value="" key="-">-</MenuItem>, ...selectionsData.managers.map((u) => <MenuItem value={u.uuid} key={u.uuid}>{u.user}</MenuItem>)]}
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box>
                        <Typography noWrap>COMPÉTENCES MÉTIERS</Typography>
                        <FormControl variant="outlined" fullWidth margin="normal">
                          <Select value={parameters?.competenceMetier ?? ""} name="competenceMetier" onChange={(e) => addParam(e)} input={<OutlinedInput name="statutCandidat" />}>
                            {loading
                                ? [<Box key="l3" display="flex" justifyContent="center"><CircularProgress /></Box>]
                                : [<MenuItem value="" key="-">-</MenuItem>, ...selectionsData.competenceMetier.map((c) => <MenuItem value={c.uuid} key={c.uuid}>{c.metier}</MenuItem>)]}
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box>
                        <Typography noWrap>COMPÉTENCES SECTORIELLES</Typography>
                        <FormControl variant="outlined" fullWidth margin="normal">
                          <Select value={parameters?.competenceSecto ?? ""} name="competenceSecto" onChange={(e) => addParam(e)} input={<OutlinedInput name="statutCandidat" />}>
                            {loading
                                ? [<Box key="l4" display="flex" justifyContent="center"><CircularProgress /></Box>]
                                : [<MenuItem value="" key="-">-</MenuItem>, ...selectionsData.competenceSecto.map((c) => <MenuItem value={c.uuid} key={c.uuid}>{c.secteur}</MenuItem>)]}
                          </Select>
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box className={classes.multi2}>
                        <Typography noWrap>COMPÉTENCES TECHNIQUES</Typography>
                        <TextField name="competenceTechnique" value={parameters?.competenceTechnique ?? ""} onChange={(e) => addParam(e)} margin="normal" variant="outlined" autoComplete="off" fullWidth />
                      </Box>
                    </Grid>
                  </>
              )}
              <Grid item xs={12}>
                <Box className={classes.multi2}>
                  <FormControl variant="outlined" fullWidth margin="normal">
                    <CustomAutoComplete multiple listData={selectionsData.societes} value={searchKeys.societe || null} handleDataChange={handleChangeSociete} name="societe" onChange={(e) => addParam(e)} />
                  </FormControl>
                </Box>
              </Grid>
              {parameters.categorie !== "contact" && (
                  <>
                    <Grid item xs={12}>
                      <Box>
                        <Typography noWrap>EXPÉRIENCE ENTRE</Typography>
                        <FormControl variant="outlined" style={{ width: "40%" }}>
                          <TextField name="start" value={parameters?.start ?? ""} onChange={(e) => addParam(e)} margin="normal" variant="outlined" autoComplete="off" fullWidth type="number" />
                        </FormControl>
                        <FormControl style={{ width: "20%", textAlign: "center", marginTop: "1em" }}>ET</FormControl>
                        <FormControl variant="outlined" style={{ width: "40%" }}>
                          <TextField name="end" value={parameters?.end ?? ""} onChange={(e) => addParam(e)} margin="normal" variant="outlined" autoComplete="off" fullWidth type="number" />
                        </FormControl>
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box>
                        <FormControlLabel
                            control={<Checkbox checked={nomFamille} onChange={(e) => handleNameChecked(e)} name="nomFamille" color="primary" />}
                            label={<Typography style={{ fontSize: "12px", fontWeight: 400 }} className={classes.fontStyle}>NOM DE FAMILLE UNIQUEMENT</Typography>}
                        />
                      </Box>
                    </Grid>
                  </>
              )}
              <Grid item xs={12}>
                <Box style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                      variant="contained"
                      type="submit"
                      style={{ backgroundColor: "#117aa7", color: "#FFF", fontWeight: "500", width: "80%" }}
                      startIcon={<BiSearch />}
                      onClick={handleApplySearch}
                  >
                    APPLIQUER
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value={tab} index={1}>
            <Box style={{ borderBottom: "1px solid #e0e0e0", marginBottom: "8px" }}>
              <Tabs
                  value={iaTab}
                  onChange={handleIaTabChange}
                  variant="fullWidth"
                  TabIndicatorProps={{ style: { background: "#117aa7" } }}
              >
                <Tab label={<Typography style={{ fontWeight: 600, fontSize: 12 }}>PAR FORMULAIRE</Typography>} />
                <Tab label={<Typography style={{ fontWeight: 600, fontSize: 12 }}>PAR TEXTE (AGENT)</Typography>} />
              </Tabs>
            </Box>

            <TabPanel value={iaTab} index={0}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <label className="input-label">LOCALISATION</label>
                  <ChipInput
                      value={ia.loc || []}
                      onAdd={(chip) => setIA({ loc: [...(ia.loc || []), chip] })}
                      onDelete={(_chip, index) => setIA({ loc: (ia.loc || []).filter((_, i) => i !== index) })}
                      placeholder="Ex: Maroc, Rabat..."
                      fullWidth
                      variant="outlined"
                  />
                  <label className="">choix multiples</label>
                </Grid>
                <Grid item xs={12}>
                  <label className="input-label">SAUF</label>
                  <TextField name="exclude" value={ia.exclude || ""} onChange={(e) => setIA({ exclude: e.target.value })} placeholder="Ex: Casa, Tanger..." fullWidth variant="outlined" />
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="input-label">COMPÉTENCES</label>
                  <ChipInput
                      value={ia.skills || []}
                      onAdd={(chip) => setIA({ skills: [...(ia.skills || []), chip] })}
                      onDelete={(_chip, index) => setIA({ skills: (ia.skills || []).filter((_, i) => i !== index) })}
                      fullWidth
                      variant="outlined"
                  />
                  <label className="">choix multiples</label>
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="input-label">LANGAGES</label>
                  <ChipInput
                      value={ia.programming_languages || []}
                      onAdd={(chip) => setIA({ programming_languages: [...(ia.programming_languages || []), chip] })}
                      onDelete={(_chip, index) => setIA({ programming_languages: (ia.programming_languages || []).filter((_, i) => i !== index) })}
                      fullWidth
                      variant="outlined"
                  />
                  <label className="">choix multiples</label>
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="input-label">RÔLE</label>
                  <TextField name="role" value={ia.role || ""} onChange={(e) => setIA({ role: e.target.value })} fullWidth variant="outlined" />
                </Grid>
                <Grid item xs={12} md={6}>
                  <label className="input-label">EXPÉRIENCE</label>
                  <Box style={{ display: "flex", gap: "16px" }}>
                    <TextField
                        type="number"
                        placeholder="min"
                        value={ia.experience?.min ?? ""}
                        onChange={(e) => setExperienceField("min", e.target.value === "" ? undefined : Number(e.target.value))}
                        fullWidth
                        variant="outlined"
                    />
                    <TextField
                        type="number"
                        placeholder="max"
                        value={ia.experience?.max ?? ""}
                        onChange={(e) => setExperienceField("max", e.target.value === "" ? undefined : Number(e.target.value))}
                        fullWidth
                        variant="outlined"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <label className="input-label">DOMAINE / INDUSTRIE</label>
                  <ChipInput
                      value={ia.industry || []}
                      onAdd={(chip) => setIA({ industry: [...(ia.industry || []), chip] })}
                      onDelete={(_chip, index) => setIA({ industry: (ia.industry || []).filter((_, i) => i !== index) })}
                      fullWidth
                      variant="outlined"
                  />
                  <label className="">choix multiples</label>
                </Grid>
                <Grid item xs={12}>
                  <Box style={{ display: "flex", justifyContent: "center", marginTop: "8px" }}>
                    <Button
                        variant="contained"
                        type="button"
                        style={{ backgroundColor: "#117aa7", color: "#FFF", fontWeight: "500", width: "80%" }}
                        startIcon={<BiSearch />}
                        disabled={iaEmpty}
                        onClick={handleApplyIaSearch}
                    >
                      APPLIQUER (IA)
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </TabPanel>

            <TabPanel value={iaTab} index={1}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <label className="input-label">ENTRER LA DESCRIPTION DU PROFIL</label>
                  <TextField
                      multiline
                      minRows={5}
                      placeholder="Entrer la description..."
                      value={agentText}
                      onChange={(e) => setAgentText(e.target.value)}
                      fullWidth
                      variant="outlined"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box style={{ display: "flex", justifyContent: "center", marginTop: "8px" }}>
                    <Button
                        variant="contained"
                        type="button"
                        style={{ backgroundColor: "#117aa7", color: "#FFF", fontWeight: "500", width: "80%" }}
                        startIcon={<BiSearch />}
                        disabled={!agentText.trim()}
                        onClick={handleApplyAgentSearch}
                    >
                      RECHERCHER (AGENT IA)
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </TabPanel>
          </TabPanel>
        </Box>
      </Box>
  );
};

export default withRouter(MultiCritere);
